import { SubscriberContactsComponent } from './cards/SubscriberContacts/subscriber-contacts.component';
import { SubscriberIdentificationComponent } from './cards/SubscriberIdentification/subscriber-identification.component';
import { ServiceIdentificationComponent } from './cards/ServiceIdentification/service-identification.component';
import { ExternalPensionStatusComponent } from './cards/ExternalPensionStatus/external-pension-status.component';
import { SubscriberFiscalInformationComponent } from './cards/SubscriberFiscalInformation/subscriber-fiscal-information.component';
import { SubscriberPaymentInformationComponent } from './cards/SubscriberPaymentInformation/subscriber-payment-information.component';
import { CGAPensionStatusComponent } from './cards/CGAPensionStatus/cga-pension-status.component';
import { EffectivityMapComponent } from './cards/EffectivityMap/effectivity-map.component';
import { MilitaryInformationComponent } from './cards/Militaryinformation/military-information.component';
import { TimeCountComponent } from './cards/TimeCount/time-count.component';
import { FamilyBenefitsComponent } from './cards/FamilyBenefits/family-benefits.component';
import { RemunerationsTrienniumComponent } from './cards/RemunerationsTriennium/remunerations-triennium.component';
import { RemunerationsLastUntilCutoffComponent } from './cards/RemunerationsLastUntilCutoff/remunerations-last-until-cutoff.component'
import { RemunerationsLastThreeYearsComponent } from './cards/RemunerationsLastThreeYears/remunerations-last-three-years.component';
import { RemunerationsCurrentMonthlyComponent } from './cards/RemunerationsCurrentMonthly/remunerations-current-monthly.component';
import { RemunerationsMilitaryComponent } from './cards/RemunerationsMilitary/remunerations-military.component';
import { DocumentationComponent } from './cards/Documentation/documentation.component';
import { DocumentationHelpComponent } from './cards/DocumentationHelp/documentation-help.component';
import { CommunicationDetailComponent } from './cards/CommunicationDetail/communication-detail.component';
import { ObservationsComponent } from './cards/Observations/observations.component';
import { ServiceContactsComponent } from './cards/ServiceContacts/service-contacts.component';
import { SendWorkflowComponent } from './cards/SendWorkflowComponent/send-workflow.component';
import { ClinicalSituationComponent } from './cards/ClinicalInformation/clinical-situation.component';
import { IncapacityEvaluationComponent } from './cards/ClinicalInformation/incapacity-evaluation.component';
import { SenderQualificationComponent } from './cards/SenderQualification/sender-qualification.component';
import { SenderIdentificationComponent } from './cards/SenderIdentification/sender-identification.component';
import { SenderObservationsComponent } from './cards/SenderObservations/sender-observations.component';
import { SenderContactsComponent } from './cards/SenderContacts/sender-contacts.component';
import { DeceasedIdentificationComponent } from './cards/DeceasedIdentification/deceased-identification.component';
import { ProfessionalCategoryComponent } from './cards/ProfessionalCategory/professional-category.component';
import { DeceasedObservationsComponent } from './cards/DeceasedObservations/deceased-observations.component';
import { WorkAbroadTableEditPMComponent } from './cards/ProfessionalCategory/work-abroad-table-edit-pm.component';
import { BeneficiaryListComponent } from './cards/BeneficiaryList/beneficiary-list.component';
import { BeneficiaryListTableEditComponent } from './cards/BeneficiaryList/beneficiary-list-table-edit.component';
import { DocumentationPMComponent } from './cards/DocumentationPM/documentation-pm.component';
import { SendWorkflowPMComponent } from './cards/SendWorkflowPM/send-workflow-pm.component';

// Registo de todos os componentes cartão
// Deve conter o nome em string como chave e a classe de componente
// Desta forma funciona mesmo que minificado
export const DynamicCardsRegister = {
  "SubscriberContactsComponent": SubscriberContactsComponent,
  "SubscriberIdentificationComponent": SubscriberIdentificationComponent,
  "ServiceIdentificationComponent": ServiceIdentificationComponent,
  "ExternalPensionStatusComponent": ExternalPensionStatusComponent,
  "SubscriberFiscalInformationComponent": SubscriberFiscalInformationComponent,
  "SubscriberPaymentInformationComponent": SubscriberPaymentInformationComponent,
  "CGAPensionStatusComponent": CGAPensionStatusComponent,
  "EffectivityMapComponent": EffectivityMapComponent,
  "MilitaryInformationComponent": MilitaryInformationComponent,
  "TimeCountComponent": TimeCountComponent,
  "FamilyBenefitsComponent": FamilyBenefitsComponent,
  "RemunerationsTrienniumComponent": RemunerationsTrienniumComponent,
  "RemunerationsLastUntilCutoffComponent": RemunerationsLastUntilCutoffComponent,
  "RemunerationsLastThreeYearsComponent": RemunerationsLastThreeYearsComponent,
  "RemunerationsCurrentMonthlyComponent": RemunerationsCurrentMonthlyComponent,
  "RemunerationsMilitaryComponent": RemunerationsMilitaryComponent,
  "CommunicationDetailComponent": CommunicationDetailComponent,
  "ObservationsComponent": ObservationsComponent,
  "DocumentationComponent": DocumentationComponent,
  "DocumentationHelpComponent": DocumentationHelpComponent,
  "ServiceContactsComponent": ServiceContactsComponent,
  "SendWorkflowComponent": SendWorkflowComponent,
  "ClinicalSituationComponent": ClinicalSituationComponent,
  "ClinicalEvaluationComponent": IncapacityEvaluationComponent,
  "SenderQualificationComponent": SenderQualificationComponent,
  "SenderIdentificationComponent": SenderIdentificationComponent,
  "SenderObservationsComponent": SenderObservationsComponent,
  "SenderContactsComponent": SenderContactsComponent,
  "DeceasedIdentificationComponent": DeceasedIdentificationComponent,
  "ProfessionalCategoryComponent": ProfessionalCategoryComponent,
  "WorkAbroadTableEditPMComponent": WorkAbroadTableEditPMComponent,
  "DeceasedObservationsComponent": DeceasedObservationsComponent,
  "BeneficiaryListComponent": BeneficiaryListComponent,
  "BeneficiaryListTableEditComponent": BeneficiaryListTableEditComponent,
  "DocumentationPMComponent": DocumentationPMComponent,
  "SendWorkflowPMComponent": SendWorkflowPMComponent
};

